import { useCopilot } from "../../../../../hooks/useCopilot";
import useMedicalEncounter from "../../../../../hooks/useMedicalEncounter";
import { Reference } from "../../../../../types/reference";
import { createEncounterParam } from "../../../../../utils/DataTransformationUtils";

/**
 * Copilot/AI-note context that works for both encounter-linked scribe and
 * standalone AI Notes (no currentEncounter).
 *
 * Patient resolution order:
 * 1. Medical encounter context patientReference
 * 2. currentEncounter.subject (when an encounter is loaded)
 * 3. copilotData.subject (standalone AI notes)
 */
export function useCopilotClinicalContext() {
  const {
    encounterReference,
    currentEncounter,
    patientReference: encounterPatientReference,
    refreshPatientHistory,
    setEncounterToInProgress,
  } = useMedicalEncounter();
  const { copilotData, setCopilotData } = useCopilot();

  const patientReference: Reference | undefined =
    encounterPatientReference ??
    currentEncounter?.subject ??
    copilotData?.subject;

  // True only when an encounter is loaded into medical-encounter context.
  // AiNoteDetail syncs active linked encounters here (and clears inactive ones).
  const hasLinkedEncounter = !!encounterReference?.identifier;
  const encounterHeaders = createEncounterParam(encounterReference);

  return {
    copilotData,
    setCopilotData,
    patientReference,
    encounterReference,
    currentEncounter,
    hasLinkedEncounter,
    encounterHeaders,
    refreshPatientHistory,
    setEncounterToInProgress,
  };
}
